<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              to="/admin/trilha"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de cursos"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui é possível visualizar o ranking de acessos do curso
              <b> {{ course.title }} </b>. Cada vez que uma startup visualiza um
              material ou responde uma avaliação ela chega mais perto de
              completar o curso.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="row">
            <div class="col-12 mb-3">
              <div
                class="card card-profile shadow vld-parent border-0"
                ref="course_image"
              >
                <div class="card-image">
                  <img
                    class="card-img-top"
                    :src="course.image || placeholderImg"
                    alt="Imagem curso"
                  />
                  <div class="image-overlay"></div>
                </div>

                <div class="card-body">
                  <h2 class="card-title mb-1">{{ course.title }}</h2>
                  <p class="description mb-0">{{ course.subtitle }}</p>
                  <p v-if="!course.is_active" class="mt-2 mb-0">
                    <badge type="warning" v-tooltip="'O curso está oculto'"
                      >Oculto</badge
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8">
          <div
            class="card shadow table-container vld-parent"
            ref="ranking_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    <i class="fas fa-award mr-2"></i> Ranking de acesso ao curso
                  </h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="orderedRanking"
                type="hover"
              >
                <template slot="columns">
                  <th>#</th>
                  <th @click="sort('nane')" class="cursor-pointer">
                    Startup
                    <i
                      :class="[
                        'ml-1 text-primary btn-sort fas',
                        sortControl.asc ? 'fa-caret-down' : 'fa-caret-up',
                      ]"
                      :title="`Ordenar ${
                        sortControl.asc
                          ? 'descendente (Z-A)'
                          : 'ascendente (A-Z)'
                      }`"
                    ></i>
                  </th>
                  <th @click="sort('completion')" class="cursor-pointer">
                    % de visualização
                    <i
                      :class="[
                        'ml-1 text-primary btn-sort fas',
                        sortControl.asc ? 'fa-caret-down' : 'fa-caret-up',
                      ]"
                      :title="`Ordenar ${
                        sortControl.asc ? 'decrescente' : 'crescente'
                      }`"
                    ></i>
                  </th>
                </template>
                <template slot-scope="{ row, index }">
                  <td class="py-4">{{ index + 1 }}</td>
                  <td>
                    {{ row.name }}
                    <router-link
                      class="ml-1"
                      title="Abrir startup"
                      :to="`/admin/startups/${row.user_id}/editar`"
                      ><i class="fas fa-eye"></i
                    ></router-link>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <span class="completion mr-2">{{ row.completion }}%</span>
                      <div>
                        <base-progress
                          :type="getProgressType(row.completion)"
                          :show-percentage="false"
                          :striped="true"
                          :animated="true"
                          class="pt-0"
                          :value="row.completion"
                        />
                      </div>
                      <span class="description text-medium ml-2">
                        {{ row.viewed_materials }} de
                        {{ material_count }} materiais visualizados
                      </span>
                    </div>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Nenhuma startup iniciou o curso e visualizou os materiais até o
                momento.
              </p>
            </div>
          </div>
          <div class="col-12 text-muted text-right mt-3" v-if="!empty">
            <b>{{ ranking.length }}</b> startups inciaram o curso ao total
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  data() {
    return {
      course: {},
      ranking: [],
      placeholderImg: "/img/pages/default_banner_course.jpg",
      sortControl: {
        currentSort: "completion",
        asc: false,
      },
      material_count: 0,
      empty: false,
    };
  },
  async mounted() {
    this.loadCourse();
    this.loadRanking();
  },
  methods: {
    async loadCourse() {
      const loader = this.$loading.show({
        container: this.$refs.course_image,
        width: 90,
        height: 90,
      });
      try {
        const { data: course } = await api.get(
          `/admin/courses/${this.$route.params.id}`
        );
        this.course = course;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações do curso"
        );
        this.$router.push("/admin/trilha");
      }
      loader.hide();
    },
    async loadRanking() {
      const loader = this.$loading.show({
        container: this.$refs.ranking_table,
        width: 90,
        height: 90,
      });
      try {
        const {
          data: { material_count, viewedRanking },
        } = await api.get(
          `/admin/courses/${this.$route.params.id}/viewed-ranking`
        );
        this.material_count = material_count;
        if (!viewedRanking.length) {
          this.empty = true;
        } else {
          viewedRanking.forEach((startup) => {
            if (!material_count) {
              startup.completion = 0;
            }
            startup.completion = Number(
              ((startup.viewed_materials / material_count) * 100).toFixed(2)
            );
          });
          this.ranking = viewedRanking;
        }
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações de acesso ao curso"
        );
        this.$router.push("/admin/trilha");
      }
      loader.hide();
    },
    sort(key) {
      this.sortControl.currentSort = key;
      this.sortControl.asc = !this.sortControl.asc;
    },
    getProgressType(completion) {
      if (completion <= 15.0) return "danger";
      if (completion <= 30.0) return "warning";
      if (completion <= 45.0) return "default";
      if (completion <= 60.0) return "info";
      if (completion < 100.0) return "primary";
      return "success";
    },
  },
  computed: {
    orderedRanking() {
      const key = this.sortControl.currentSort;
      const compareFunction = function (a, b) {
        return a[key] > b[key] ? 1 : -1;
      };
      const ranking = [...this.ranking].sort(compareFunction);
      return this.sortControl.asc ? ranking : ranking.reverse();
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
.material-item {
  background: #fff;
  color: #525f7f;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}
.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}

.cursor-pointer {
  cursor: pointer;
}

.text-medium {
  font-size: 95%;
}
</style>
